import { Component, ViewChild } from "@angular/core";
import { galleryTransition, fadeInOutAnimation } from "../../animations";
import { Catalog } from "../../data/catalog";
import { CatalogService } from "../../services/catalog.service";
import { Router } from "@angular/router";
import { OnInit } from "@angular/core";
import { WindowService } from "../../services/window.service";
import { SupermodalComponent } from "@app/components/common/supermodal.component";

@Component({
  templateUrl: "./order-sheets.list.component.html",
  animations: [galleryTransition, fadeInOutAnimation],
})
export class OrderSheetsListComponent implements OnInit {
  catalogs: Catalog[] = [];
  animationInitialized: boolean = false;
  page: number = 0;
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private catalogService: CatalogService,
    private windowService: WindowService
  ) {}

  getCatalogs(): void {
    this.isLoading = true;
    this.catalogService.getCatalogs("", this.page).then((catalogs) => {
      this.catalogs.push(...catalogs);
      this.isLoading = false;
    });
  }

  ngOnInit(): void {
    this.getCatalogs();
  }

  // change the animation state
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

  onScroll() {
    this.page += 1;
    this.getCatalogs();
  }
}
